// extracted by mini-css-extract-plugin
module.exports = {"stat-item":"StatItem_stat-item__3MlSq"};